/**
 * Shared context-usage thresholds for the session header usage chip and
 * usage threshold reminders. Percent values are 0-100 of the context window.
 */
export const USAGE_WARN_PERCENT = 80;
export const USAGE_CRITICAL_PERCENT = 95;
